import React from 'react';
import {Button, Stack} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {useMediaQueries} from 'presentation/pages';
import {AddressFooterProps} from './types';

const {cancel} = translations['pt-br'].commons;

export function AddressFooter({
	children,
	loading = false,
	withoutCancelButton = false,
	responsiveButtons = false,
	onBack,
}: AddressFooterProps) {
	const {isMobile} = useMediaQueries();

	return (
		<Stack
			direction={responsiveButtons && isMobile ? 'column' : 'row'}
			flex={1}
			justifyContent={responsiveButtons && isMobile ? 'center' : 'flex-end'}
			spacing={2}
			mt={responsiveButtons && isMobile ? 2 : undefined}>
			{!withoutCancelButton && (
				<Button disabled={loading} size="large" variant="outlined" onClick={onBack}>
					{cancel}
				</Button>
			)}
			{children}
		</Stack>
	);
}
